/* eslint-disable */
import axios from 'axios';
import Cookies from 'js-cookie'
import getBrowserFingerprint from 'get-browser-fingerprint'
import { useLoading } from 'vue-loading-overlay'


export interface APIInterface {
    setAuthentication(auth : any, url : any) : void
    post(url : string, data : any) : Promise<any>
    put(url : string, data : any) : Promise<any>
    get(url : string, search? : string, page? : number) : Promise<any>
    delete(url : string) : Promise<any>
}

export class APIClient {

	private instance : any
	private basePath = process.env.VUE_APP_API_URL;

	constructor(auth : any = {}, url : any = null){

    const fg = getBrowserFingerprint({
      enableWebgl: true,
    })

    auth.device = fg 
		this.setAuthentication(auth, url)
	}

	public setAuthentication(auth : any, url : any) : void {

		if (url){
			this.basePath = url
		}

		this.instance = axios.create({
			baseURL: this.basePath,
			timeout: 8000,
			headers: auth,
      withCredentials: true,
		});

    const $loading = useLoading({
      color: "#D0A441",
      "background-color": "#333",
    } as any);

      this.instance.interceptors.request.use(function (config : any) {
        

        if(!config.url?.includes("?search=")){
          const loader = $loading.show({
          // Optional parameters
          });
          config.loader_obj = loader
       }
        
        return config;
      }, function (error : any) {
        
        // Do something with request error
        return Promise.reject(error);
      });

      this.instance.interceptors.response.use(function (response : any) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        response.config.loader_obj?.hide()


        return response;
      }, function (error : any) {

        if(error.config.loader_obj)
          error.config.loader_obj.hide()

        if(error?.response?.status == 401){
          //destroy session and send to login
          const settings : any = process.env.NODE_ENV == 'development' ? {} : {
            secure: true, 
            domain: process.env.VUE_APP_DOMAIN,
            sameSite: "Strict",
          };

          Cookies.remove("API_TOKEN", settings)
          window["location"] = "/login" as any
        }
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
      });
	}

	public async post(url : string, data : any) : Promise<any> {
		return this.instance.post(url, data)
	}

	public async put(url : string, data : any) : Promise<any> {
		return this.instance.post(url, data)
	}

	public async get(
        url : string, 
        search : string = "", 
        page : number = -1,
    ) : Promise<any> {

        const opts = {
            headers: {'page': page},
        }


        if(page !== -1){
            const urlformatted = `${url}?search=${search}`
            return this.instance.get(urlformatted, opts)
        }

    return this.instance.get(url, opts)
  }

	public async delete(url : string) : Promise<any> {
		return this.instance.get(url + "/delete")
	}

}

export interface LoginRequest {
	username : string;
	password : string;
  TOTP : string;
}

export interface User {
  _id: number
  active: boolean
  address: string
  created_at: Date
  current_login_at: string
  email: string
  employee_code: string
  enable: boolean
  first_name: string
  groups: string[]
  has_first_login: boolean
  last_login_at: string
  last_name: string
  middle_name: string
  mobile: string
  password_updated_on: string
  roles: Role[]
  updated_at: Date
  username: string
  ip_white_list : string[]
  employee : any
}

export interface Application {
  _id: number
  created_at: string
  name: string
  updated_at: string
  url: string
  user_id: string
}

export interface Role {
  _id: number
  created_at?: Date
  enable: boolean
  microservice_id: number
  name: string
  grant : boolean
  sub_role_map : string[]
  sub_roles: string[]
  groups : string[]
  updated_at: Date
}

export interface SubRole {
  _id: number
  created_at?: Date
  name: string
  updated_at: Date
  user_id: string
}

export interface Shortcut {
  name: string
  url : string
}

export interface Service {
  _id: number
  created_at?: Date
  group_options : any[]
  enable: boolean
  group: string
  shortcuts :Shortcut[]
  api_protocol: string
  frontend_path : string
  roles : Role[]
  groups : string[]
  service_name: string
  display_name: string
  updated_at: Date
  url: string
  properties : any
}

export interface IDP {
  _id: number
  created_at?: Date
  name: string
  updated_at: Date
  url: string
  user_id: string
}

export interface ImportColumn {
  name : string
  comArray? : boolean
  column : string
  required?: boolean
  // Which column to use from 
  // excel.
  targetColumn? : number
}



